import React from 'react'
import { useTranslation } from 'react-i18next'
import { NumberInput } from '../../../../../../common/inputs/numberInput/NumberInput'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'
import { formatNumber } from '../../../../../../../i18next/decimal'

export interface RentalIncomeActualProps {
  wrapperClassName?: string
  property: 'rentalIncomeActual' | 'rentalIncomeTarget'
}

const RentalIncomeFieldFactory: React.FC<
  FieldProps<OtherFacilitiesScreenValidationResult> & RentalIncomeActualProps
> = ({ screenName, insertionData, validationMessages, property, onChange }) => {
  const { t } = useTranslation()
  const errors =
    property === 'rentalIncomeTarget' ? validationMessages!.rentalIncomeTarget : validationMessages!.rentalIncomeActual
  return (
    <NumberInput
      id={`${property}-field`}
      propertyName={property}
      label={t(`wizard.screen.otherFacilities.${property}Field`, 'Rental income actual')}
      value={insertionData[property] ? parseNumber(insertionData[property]) : undefined}
      minPrecision={0}
      maxPrecision={2}
      affixRight='unit'
      unitRight='eur'
      errors={errors ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, formatNumber(value))}
    />
  )
}

export default RentalIncomeFieldFactory
